import { useEffect, useRef, useLayoutEffect, useState } from "react";
import styles from "./DropdownMenu.module.scss";
import { createPortal } from "react-dom";
import { LeaveCabinet } from "../../assets/LeaveCabinet";

interface DropdownMenuProps {
  onClose: () => void;
  onLeave: () => void;
  buttonRect: DOMRect;
}

export function DropdownMenu({
  onClose,
  onLeave,
  buttonRect,
}: DropdownMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<{ top: number; left: number }>({
    top: -9999,
    left: -9999,
  });

  useLayoutEffect(() => {
    if (menuRef.current && buttonRect) {
      const menuWidth = menuRef.current.offsetWidth;
      const windowWidth = window.innerWidth;
      const margin = 10;

      let left = buttonRect.left;
      if (left + menuWidth > windowWidth - margin) {
        left = buttonRect.right - menuWidth;
      }

      setPosition({
        top: buttonRect.bottom + 5,
        left,
      });
    }
  }, [buttonRect]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const isClickOnButton =
        buttonRect &&
        event.clientX >= buttonRect.left &&
        event.clientX <= buttonRect.right &&
        event.clientY >= buttonRect.top &&
        event.clientY <= buttonRect.bottom;

      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        !isClickOnButton
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose, buttonRect]);

  return createPortal(
    <div
      ref={menuRef}
      className={styles.dropdownMenu}
      style={{ top: `${position.top}px`, left: `${position.left}px` }}
    >
      <button
        onClick={() => {
          onLeave();
        }}
        className={styles.dropdownItem}
      >
        <LeaveCabinet /> Покинуть кабинет
      </button>
    </div>,
    document.body,
  );
}
